"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
export function useSearchParamsSSR() {
  const $ = _c(3);
  const [searchParams, setSearchParams] = useState(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof window !== "undefined") {
        setSearchParams(new URLSearchParams(window.location.search));
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const updateSearchParams = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      updateSearchParams();
      window.addEventListener("popstate", updateSearchParams);
      return () => window.removeEventListener("popstate", updateSearchParams);
    };
    t2 = [updateSearchParams];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return searchParams;
}
function _temp() {
  if (typeof window === "undefined") {
    return new URLSearchParams();
  }
  return new URLSearchParams(window.location.search);
}
export function useSearchParam(param) {
  const $ = _c(3);
  const searchParams = useSearchParamsSSR();
  let t0;
  if ($[0] !== param || $[1] !== searchParams) {
    t0 = searchParams.get(param);
    $[0] = param;
    $[1] = searchParams;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}